import React from "react";
import Layout from "../../components/layouts/Layout";
import MessagingSystem from "./overview/MessagingSystem";
import StaffRecords from "./overview/StaffRecords";
import HolidaysAbsence from "./overview/HolidaysAbsence";
import Roster from "./overview/Roster";
import StaffOverviewBlocks from "../../components/general/StaffOverviewBlocks";
import ProtectedComponent from "../../permissions/ProtectedComponent";
import { permissions } from "../../permissions/roles";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import MedicationOverview from "./overview/MedicationOverview";
import StaffRecordsGroup from "../staff_records/StaffRecordsGroup";
function StaffOverview() {
  return (
    <Layout pageTitleText="Staff Overview">
      <div className="staffOverview">
        <StaffOverviewBlocks />
        <div className="row">
          <div className="col-md-6">
            <div className="mainContent rowClickUnset h-100">
              <Roster staffHeadingBlock="Roster" />
            </div>
          </div>
          <div className="col-md-6">
            <PermissionWrapper title="Emar" action="view">

              {/* <div className="mainContent">
                <HolidaysAbsence staffHeadingBlock="Holidays & Absence" />
              </div> */}
              <div className="mainContent">
                <MedicationOverview staffHeadingBlock="Medication Tasks" />
              </div>

            </PermissionWrapper>
          </div>
          <PermissionWrapper title="Staff" action="view">
            <div className="col-md-12">
              <div className="mainContent staffRecords">
                <StaffRecordsGroup actionButtonsComponent={false} />
                {/* <StaffRecords staffHeadingBlock="Staff Records" /> */}
              </div>
            </div>
          </PermissionWrapper>
          {/* <div className="col-md-4">
            <div className="mainContent messagingSystem">
              <MessagingSystem staffHeadingBlock="Messaging System" />
            </div>
          </div> */}
        </div>
      </div>
    </Layout>
  );
}

export default StaffOverview;
